import React from 'react';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Form, Input } from 'components/antd';
import styles from './FirstLastNameInputs.module.scss';

interface Props {
	form: WrappedFormUtils;
	firstName: string;
	lastName: string;
}

export const FirstLastNameInputs: React.FC<Props> = ({ form, firstName, lastName }) => {
	const { getFieldDecorator } = form;

	return (
		<div className={styles.separatedNamesHolder}>
			<div className={styles.separatedNamesItem}>
				<Form.Item label="First name" validateStatus={''} help={false}>
					{getFieldDecorator('firstName', {
						initialValue: firstName,
						rules: [
							{
								required: true,
								whitespace: true,
							},
						],
					})(<Input />)}
				</Form.Item>
			</div>
			<div className={styles.separatedNamesItem}>
				<Form.Item label="Last name" validateStatus={''} help={false}>
					{getFieldDecorator('lastName', {
						initialValue: lastName,
						rules: [
							{
								required: true,
								whitespace: true,
							},
						],
					})(<Input />)}
				</Form.Item>
			</div>
		</div>
	);
};
